<div class="error-card">
  <div class="icon-wrapper">
    <umkt-icon [icon]="{ name: 'circulo-exclamacao', type: 'mondrian-icons' }"></umkt-icon>
  </div>

  <div class="text-area">
    <p class="title">{{ title | i18n }}</p>

    <p class="description" [innerHTML]="description | i18n"></p>
    <p class="description" [innerHTML]="subDescription | i18n"></p>
  </div>
  
  <button class="action-button" (click)="onActionButtonClick()">
     <umkt-icon *ngIf="!shouldShowRetryButton" [icon]="{ name: 'seta-esquerda', type: 'mondrian-icons' }" [size]="'sm'"></umkt-icon>
    {{ (shouldShowRetryButton ? 'components.errorDisplay.retryButton' : 'components.errorDisplay.backHomeButton') | i18n }}
  </button>
</div>